var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeScreen === _vm.ScreensEnum.conversationClient,
            expression: "activeScreen === ScreensEnum.conversationClient",
          },
        ],
        staticClass: "container-fluid",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("div", { staticClass: "panel" }, [
              _c(
                "div",
                {
                  staticClass:
                    "clearfix panel-heading branding-background branding-text chat-heading",
                },
                [
                  _c("h3", { staticClass: "panel-title pull-left" }, [
                    _c("i", { staticClass: "glyphicon glyphicon-comment" }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.agentName) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pull-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "branding-text min-chat",
                        attrs: { href: "", title: "Minimize Chat" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nextScreen(_vm.ScreensEnum.chatButton)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "glyphicon glyphicon-menu-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "branding-text close-chat",
                        attrs: {
                          href: "",
                          title: [_vm.activeChat ? "End Chat" : "Close Chat"],
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleEndChatScreen(true)
                          },
                        },
                      },
                      [_c("i", { staticClass: "glyphicon glyphicon-remove" })]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "panel-body chat-window",
                  attrs: { id: "chat-window" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "list-unstyled text-right" },
                    _vm._l(_vm.messages, function (item) {
                      return _c(
                        "div",
                        { key: item.message, staticClass: "clearfix" },
                        [
                          _c(
                            "li",
                            {
                              staticClass: "panel",
                              class: [
                                item.direction === _vm.MessageDirection.Outgoing
                                  ? "outgoing-response"
                                  : "incoming-response",
                              ],
                            },
                            [
                              _c(
                                "ul",
                                { staticClass: "list-unstyled panel-body" },
                                [
                                  _c("li", {
                                    domProps: {
                                      innerHTML: _vm._s(item.message),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "text-muted timestamp-response",
                                    },
                                    [
                                      _c("small", {
                                        domProps: {
                                          innerHTML: _vm._s(item.name),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.awaitingAgent,
                          expression: "awaitingAgent",
                        },
                      ],
                      staticClass: "text-muted text-left awaiting-response",
                    },
                    [_c("small", [_vm._v("Awaiting agent...")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.activeChat,
                          expression: "!activeChat",
                        },
                      ],
                      staticClass: "text-muted text-center end-response",
                    },
                    [
                      _vm._v("Your conversation has ended."),
                      _c("br"),
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.nextScreen(_vm.ScreensEnum.transcript)
                            },
                          },
                        },
                        [_vm._v("Click here for a transcript.")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body chat-reply" }, [
                _c("div", { staticClass: "input-group input-group-lg" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message,
                        expression: "message",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "btn-input",
                      type: "text",
                      placeholder: "Type your message here...",
                      maxlength: "250",
                    },
                    domProps: { value: _vm.message },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendMessage.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.message = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn branding-background branding-text send-response",
                        attrs: {
                          disabled: _vm.disableSendMessageButton,
                          id: "",
                        },
                        on: { click: _vm.sendMessage },
                      },
                      [_c("i", { staticClass: "glyphicon glyphicon-send" })]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showEndChatScreen,
            expression: "showEndChatScreen",
          },
        ],
        staticClass: "container-fluid",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "text-center chat-end" }, [
            _c("h3", [_vm._v("End this chat?")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-lg",
                attrs: { id: "" },
                on: { click: _vm.endChat },
              },
              [_vm._v("End Chat")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-lg",
                attrs: { id: "" },
                on: {
                  click: function ($event) {
                    return _vm.toggleEndChatScreen(false)
                  },
                },
              },
              [_vm._v("Return")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }